import { render, staticRenderFns } from "./HighlightsPostItemContentsParts.vue?vue&type=template&id=275c2a2a&scoped=true"
import script from "./HighlightsPostItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./HighlightsPostItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./HighlightsPostItemContentsParts.vue?vue&type=style&index=0&id=275c2a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c2a2a",
  null
  
)

export default component.exports